import { render, staticRenderFns } from "./qs2-13.vue?vue&type=template&id=ab7c5060&scoped=true&"
import script from "./qs2-13.vue?vue&type=script&lang=js&"
export * from "./qs2-13.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7c5060",
  null
  
)

export default component.exports